import { BaseSVGType } from '@/components/common/svg/types/svgTypes.ts';

const HeartArrowShape = ({
  width = 56,
  height = 56,
  fillColor = '#fff',
  style
}: BaseSVGType) => (
  <svg
    fill={fillColor}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    style={style}
    viewBox="0 0 362.685 362.685"
  >
    <g>
      <path
        d="M348.601,43.01c7.956-1.224,18.359,7.344,12.239,15.912c-11.016,15.3-20.808,31.212-28.151,48.96
		c-3.672,9.18-17.748,11.016-20.809,0c-1.836-6.732-3.06-13.464-3.672-20.196c-10.404,8.568-20.808,16.524-31.212,25.092
		c6.12,10.404,8.568,23.256,7.344,36.72c-7.344,64.26-73.439,146.88-144.432,134.64c-18.972-3.06-39.168-12.853-58.14-26.928
		c-9.792,6.731-19.584,12.852-29.376,19.584c0.612,3.672,0,6.731-0.612,10.403c-1.224,7.345-1.836,14.688-3.06,22.032
		c-1.836,13.464-22.032,14.688-22.032,0c0-7.956-0.612-17.136,1.836-24.479c-6.732-3.061-13.464-4.896-20.808-6.732
		c-13.464-3.06-7.956-23.256,6.12-20.808c9.18,1.836,23.256,3.06,31.212,9.18c7.956-6.12,15.912-12.853,23.868-18.972
		C36.48,218.042,15.06,175.813,29.136,137.87c22.644-60.588,94.248-61.2,132.804-21.42c20.808-22.032,49.572-38.556,80.785-29.376
		c9.18,2.448,16.523,6.732,22.644,12.24c9.792-7.344,19.584-14.688,29.376-22.032c-3.672-1.224-7.344-2.448-11.016-3.672
		c-9.181-3.06-11.628-18.972,0-20.808C305.76,49.742,327.18,46.07,348.601,43.01z M94.62,109.718c-2.448,0-4.284,0.612-6.732,1.224
		c-27.54,7.344-45.288,35.496-39.78,63.648c1.224,6.12,4.284,12.852,7.344,19.584c-1.836-11.628-1.224-23.256,0.612-31.212
		C62.184,143.377,76.26,121.346,94.62,109.718z"
      />
    </g>
  </svg>
);

export default HeartArrowShape;
